import styled from 'styled-components/macro';

export const ImageUploadButton = styled.button<{
  width?: string;
  height?: string;
  border?: string;
  backgroundColor?: string;
  borderRadius?: string;
  margin?: string;
  padding?: string;
  isDragging?: boolean;
}>`
  position: relative;
  width: ${({ width }) => width || '100%'};
  height: ${({ height }) => height || '2.5rem'};
  border: ${({ theme, border }) => border || `dashed 1px ${theme.colors.black_20}`};
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor || `${theme.colors.black_20}`};
  background-color: ${({ theme, isDragging }) => isDragging && `${theme.colors.black_10}`};
  border-radius: ${({ theme, borderRadius }) => borderRadius || `${theme.spacing.zero_1}`};
  margin: ${({ margin }) => margin && margin};
  padding: ${({ theme, padding }) => padding || `${theme.spacing.one}`};

  ${({ isDragging, theme }) =>
    isDragging &&
    `
    border-color: ${theme.colors.primary};

    p {
    color: ${theme.colors.primary};
    }

    svg > path {
      stroke: ${theme.colors.primary};
    `}

  :hover {
    cursor: pointer;
  }
`;

export const UploadedImage = styled.img<{ border?: string }>`
  max-width: 100%;
  height: auto;
  object-fit: cover;
  border: ${({ border }) => (border ? border : '1px solid')};
  border-color: transparent;
  border-radius: ${({ theme }) => theme.spacing.zero_1};
  :hover {
    border-color: ${({ theme }) => theme.colors.black_40};
  }
`;

export const DeleteIcon = styled.div<{ top?: string; right?: string }>`
  position: absolute;
  top: ${({ top, theme }) => (top ? top : theme.spacing.one)};
  right: ${({ right, theme }) => (right ? right : theme.spacing.one)};
`;

export const ErrorWrapper = styled.div`
  position: absolute;
  top: calc(50% - 22px);
  left: calc(50% - 64px);

  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ErrorMessageWrapper = styled.div`
  width: 8.25rem;
  margin: 0 auto ${({ theme }) => theme.spacing.one};
  padding: ${({ theme }) => `${theme.spacing.zero_1} ${theme.spacing.zero_2}`};
  border-radius: ${({ theme }) => theme.spacing.zero_1};

  background-color: rgba(251, 78, 78, 0.8);
`;

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-family: ${({ theme }) => theme.fontFamily.medium};
  text-align: center;
`;
